import './App.css';
import Timer from './Timer'
import discover from './assets/discover.svg'
import share from './assets/share.svg'
import collab from './assets/collab.svg'
import React from 'react';

function App() {

  const [join, setJoin] = React.useState(false);

  const handleclick = () => {
    setJoin(true);
  }

  return (
    <>
      <link href='https://fonts.googleapis.com/css?family=Lato:300,400,700' rel='stylesheet' type='text/css' />
      <div id='stars'></div>
      <div id='stars2'></div>
      <div id='stars3'></div>
      <div id='title'>
        <span className='tits'>
          ClgSpace
        </span>
        <br />
        <span className='titsdisc'>
          Shall Break The Boundaries Between The Branches & Batches In
        </span>
        <br />
        <div className='timer' >
          <span><Timer /></span>
        </div>
        <br />
        <div className='value'>
          <img src={discover} id='img' />
          <div>Discover</div>
          <span className='disc'>
            What's happeing in the re-activated college clubs
          </span>
        </div>
        <div className='value'>
          <img src={share} id='img' />
          <div>Share </div>
          <span className='disc'>
            Your blogs, vlogs & ideas with our institute's first ever <br /> peer-to-peer learning platform
          </span>
        </div>
        <div className='value'>
          <img src={collab} id='img' style={{ marginTop: '5%' }} />
          <div>Collab</div>
          <span className='disc'>
            With fellow students, alumni & faculty members to build great <br /> open source projects
          </span>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <div className='wishlist'>
            <h5 style={{ marginTop: '2%' }}>Support us by joining our wishlist</h5>
            <button disabled={join} style={{ fontSize: 'large', fontWeight: 'bold', marginTop: '-3%', marginBottom: '3%', height: '50px', width: '200px' }} onClick={handleclick}>{join ? "YOU ARE IN" : "COUNT ME IN!"}</button>
          </div>
        </div>
      </div>
    </>
  );
}

export default App;
